module.exports = __webpack_public_path__ + "static/NeueMontreal-MediumItalic-d169b8b7b6a2abc812ae4401c7eb82ef.woff2";